import config from '@/config/config';
function rem() {
  var docEl = document.documentElement;
  var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
  // var _this = this;
  var reFn = function () {
    var clientWidth = docEl.clientWidth;
    var width;
    if (clientWidth < 750) {
      width = clientWidth;
    } else {
      width = 750;
    }
    docEl.style.fontSize = 100 * (width / 750) + 'px';
    config.fontSize = 100 * (width / 750);
  };
  reFn();
  window.addEventListener(resizeEvt, reFn, false);
  document.addEventListener('DOMContentLoaded', reFn, false);
}

export default rem;